import { useQuery } from "@tanstack/react-query";
import { useProductionService } from "../services/production";

export function useProductionBaseline(days: number = 30) {
  const service = useProductionService();
  return useQuery({
    queryKey: ["production-baseline", days],
    queryFn: () => service.getBaseline(days),
    staleTime: 30 * 60_000, // 30 min
    refetchInterval: false, // manual refresh only — baseline changes slowly
  });
}
